import { ProductsConfig } from '../../../interfaces/mock.interface';

export const OPTIONS_MOCK: ProductsConfig[] = [
    {
        label: 'Pack sécurité Norton',
        gencode: '13071',
    },
    {
        label: 'B.tv - TV en direct illimitée',
        gencode: '12914',
    },
    {
        label: 'Disney+',
        gencode: '14371',
    },
];
export const ACCESSORIES_MOCK: ProductsConfig[] = [
    {
        label: 'Apple Écouteurs AirPods 2ᵉ génération',
        gencode: '0190199098572',
    },
    {
        label: 'Apple Écouteurs AirPods 3ᵉ génération avec boîtier de charge MagSafe',
        gencode: '0194252818527',
    },
    {
        label: 'Xiaomi Pack connecté',
        gencode: '3662515018740',
    },
];
